export default "__VITE_ASSET__Dg4XLME4__"